{
  "settings": "Configurações",
  "yourDigitalAssistant": "Seu Assistente Digital",
  "getStarted": "Iniciar",
  "login": "Conecte-se",
  "loggingIn": "A iniciar sessão ...",
  "darkMode": "Modo escuro",
  "clearHistory": "Limpar histórico",
  "historyCleared": "História limpa",
  "changeLanguage": "Idioma",
  "termsAndConditions": "Termos e condições",
  "messagePlaceholder": "Digite sua mensagem aqui ...",
  "messagePlaceholderDisabled": "Digitando desativado ...",
  "feedbackTitle": "Avalie sua experiência",
  "feedbackPlaceholder": "Nos fale mais (opcional)",
  "feedbackSend": "Enviar",
  "feedbackClose": "Fechar",
  "sessionExpired": "Sua sessão expirou devido à inatividade.",
  "startNewSession": "Iniciar uma nova sessão",
  "apiError": "Opa! Algo deu errado. Estamos trabalhando para corrigir isso o mais rápido possível.",
  "apiErrorOffline": "Você não está conectado à Internet.",
  "tryAgain": "Tente novamente",
  "startOver": "Recomeçar",
  "chatEnded": "O bate-papo terminou.",
  "chatEndedThankYou": "Obrigado por nos contatar, até logo!",
  "closeChat": "Fechar",
  "startNewChat": "Conversar de novo",
  "humanTakeoverStarted": "Agora você está sendo transferido para o atendimento ao cliente ...",
  "humanTakeoverQueued": "Aguardando a conexão com um agente",
  "humanTakeoverAnAgent": "Um agente",
  "humanTakeoverAgentEntered": "entrou na conversa",
  "humanTakeoverAgentLogout": "deixou a conversa",
  "humanTakeoverTransfer": "Você está sendo transferido para um novo agente",
  "humanTakeoverEnded": "Agora você está conversando com seu assistente digital",
  "version": "Versão",
  "formIntroText": "Por favor, preencha o seguinte formulário para começar a conversar conosco.",
  "formFirstName": "Primeiro nome",
  "formLastName": "Sobrenome",
  "formName": "Name",
  "formEmail": "E-mail",
  "formWrongEmail": "Forneça um endereço de email válido.",
  "formPhone": "Telefone",
  "formShipmentId": "ID da remessa",
  "formQuestion": "Sua pergunta",
  "formAccountNumber": "Número da conta (para clientes empresariais)",
  "formAddress": "Endereço",
  "formPostcode": "Código postal",
  "formCity": "Cidade",
  "formCountry": "País",
  "formSubmitButton": "Iniciar bate-papo",
  "formEmptyFieldError": "Não é permitido que esteja vazio.",
  "formPhoneNumberValidationError": "Não é um número de telefone válido.",
  "formInputIsBiggerThan50": "Deve ter no máximo 50 caracteres.",
  "formInputIsBiggerThan100": "Deve ter no máximo 100 caracteres.",
  "formInputIsBiggerThan2000": "Deve ter no máximo 2000 caracteres.",
  "widgetEventOnline": "Mensagem DA: O usuário está online novamente.",
  "widgetEventHidden": "Mensagem DA: o widget está oculto.",
  "widgetEventVisible": "Mensagem DA: o widget está visível.",
  "widgetEventVisibleMinimized": "Mensagem DA: o widget está visível, mas minimizado.",
  "widgetEventMinimized": "Mensagem DA: o widget é minimizado.",
  "widgetEventMaximized": "Mensagem DA: o widget está maximizado.",
  "widgetEventSessionExpired": "Mensagem DA: a sessão do widget expirou.",
  "widgetEventHangupHuman": "Mensagem DA: Usuário encerrando sessão de aquisição humana.",
  "widgetEventUserTyping": "Mensagem DA: o usuário está digitando.",
  "fileTooLarge": "Você está tentando anexar arquivos muito grandes.",
  "tooManyDiles": "Você está tentando anexar muitos arquivos.",
  "fileInvalidType": "Você está tentando anexar tipos de arquivo inválidos.",
  "attachmentsDropHere": "Solte aqui para fazer upload ou",
  "attachmentsBrowse": "Procurar arquivos",
  "attachmentsExtenstionQuantity": "PDF ou imagens (até 10 arquivos)",
  "attachmentsSize": "até 30 MB",
  "attachmentsFailedUploading": "Falha no upload",
  "attachmentsUploading": "Enviando...",
  "minimizeExpandText": "Converse ao vivo com a gente agora!",
  "popupWidgetNotificationMessage": "Você recebeu uma nova mensagem!",
  "tabWidgetNotificationMessage": "Nova mensagem!",
  "datepickerSendButton": "enviar"
}
